import React from "react";
import {withRouter} from 'react-router-dom';
import queryString from 'qs'
import MaterialTable from 'material-table';


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress } from '@material-ui/core';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import axios from "axios";
import { addressToOneLine, getApiHeaders, phoneToDisplay } from "../../../assets/helpers/apiHelper";
import { getSearchString } from "../../../assets/helpers/urlHelper";
import { API_ROOT, SUPPORT_EMAIL } from 'api-config';

import PreLoginHeader from "components/Header/PreLoginHeader.jsx";
const tableStyle = require('../../../assets/style/tableStyle.json');
var tableOptions = require('../../../assets/style/tableOptions.json');
tableOptions = JSON.parse(JSON.stringify(tableOptions));
tableOptions.pageSize = 5;
tableOptions.search = false;

const usStateList = require('../../../assets/selectLists/usStates.json');


const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px"
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch
};

class Dentist extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmitProviderSearch = this.onSubmitProviderSearch.bind(this);
    var headerText = 'Please search for and select your dentist.'
    var subheaderText = ''
    var confirmationText = 'Or click "next" if to continue signing up.'
    var showConfirmButton = false
    var showPreLoginHeader = false
    if (this.props.location.pathname !== '/signup') {
      headerText = 'You need to select a dentist before you proceed.'
      subheaderText = 'You can search for your dentists and select from the search results.'
      confirmationText = 'Or click "confirm" to continue.'
      showConfirmButton = true
      showPreLoginHeader = true
    }
    this.state = {
      searchData: [],
      providerFirstName: "",
      providerLastName: "",
      providerState: "MA",
      showSearchOption: true,
      selectedProviderId: "",
      selectedProviderName: "",
      selectedProviderCity: "",
      selectedProviderState: "",
      selectedProviderAcceptCreditCards: "",
      selectedProviderChargeCreditCardFee: false,
      selectedProviderCreditCardFee: "",
      selectedProviderAllowMonthlyPlans: "",
      selectedProviderAllowAnnualPlans: "",
      showProviderSearchResults: false,
      invitationCode: "",
      headerText: headerText,
      subheaderText: subheaderText,
      confirmationText: confirmationText,
      showConfirmButton: showConfirmButton,
      updateStatusMessage: '',
      updateStatusIndicator: '',
      disableUpdateButton: false,
      showPreLoginHeader: showPreLoginHeader,
      haveProviderFromUrl: false
    };
  }

  componentDidMount() {
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    if (values.provider) {
      var invitationCode = ""
      if (values.invitationCode && values.invitationCode !== undefined) {
        invitationCode = values.invitationCode
      }
      axios.get(`${API_ROOT}/providerSearch/?providerUuid=`+values.provider+`&invitationCode=`+invitationCode, {headers: getApiHeaders()})
        .then(res => this.selectProvider({responseMessage: res.data[0]}));
      this.setState({
        selectedProviderId: values.provider,
        invitationCode: invitationCode,
        haveProviderFromUrl: true,
        headerText: "",
        showSearchOption: false
      })
    }
  }

  sendState() {
    return this.state;
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }
  isValidated() {
    if (
      this.state.selectedProviderId !== ""
    ) {
      return true;
    }
    return false;
  }


  onSubmitProviderSearch(e) {
    this.setState({
      showProviderSearchResults: true,
      searchData: [{ id: 0, name: 'loading...', dentists: 'loading...',
        address: 'loading...', addressCity: 'loading...', addressState: 'loading...',
        addressZip: 'loading...', phone: 'loading...', actions: 'loading...' }]
    })
    e.preventDefault();
    axios.get(`${API_ROOT}/providerSearch/?addressState=`+this.state.providerState+`&lastName=`+this.state.providerLastName+`&firstName=`+this.state.providerFirstName, {headers: getApiHeaders()})
      .then(res => this.setProviderSearchResponse({responseMessage: res.data}));

  }

  getProviderButtonId(providerId) {
    return "selectProvider_" + providerId
  }

  setProviderSearchResponse(res) {
    this.setState({
      searchData: res.responseMessage.map((prop, key) => {
        return {
          id: prop.userId,
          name: prop.name,
          dentists: JSON.parse(prop.linkedPeople).map((provider, key) => {
            return (<li key={key}>
              {provider.firstName} {provider.middleName} {provider.lastName}
              {provider.suffix !== "" ?
                ', '
                : ''}
              {provider.suffix}
              {provider.title !== "" ?
                ', '
                : ''}
              {provider.title}</li>)
          }),
          address: addressToOneLine(prop.address1, prop.address2),
          addressCity: prop.city,
          addressState: prop.state,
          addressZip: prop.zip,
          phone: phoneToDisplay(prop.phone),
          actions: (<Button
            color="success"
            simple
            onClick={() => this.selectProvider(prop)}
            id={this.getProviderButtonId(prop.userId)}
          >
            <AddIcon />
          </Button>)
        };
      })
    });
  }

  selectProvider(providerInfo) {
    if (providerInfo.responseMessage) {
      providerInfo = providerInfo.responseMessage
    }
    if (providerInfo.userId) {
      this.setState({
        selectedProviderId: providerInfo.userId,
        selectedProviderName: providerInfo.name,
        selectedProviderCity: providerInfo.city,
        selectedProviderState: providerInfo.state,
        selectedProviderAcceptCreditCards: providerInfo.acceptCreditCards,
        selectedProviderChargeCreditCardFee: providerInfo.chargeCreditCardFee,
        selectedProviderCreditCardFee: providerInfo.creditCardFee,
        selectedProviderAllowMonthlyPlans: providerInfo.allowMonthlyPlans,
        selectedProviderAllowAnnualPlans: providerInfo.allowAnnualPlans
      })

      this.toggleSearch(false)
    } else {
      this.setState({
        headerText: "Please search for and select your dentist."
      })
    }
  }

  toggleSearch(toggleAction) {
    this.setState({
      showSearchOption: toggleAction
    })
    if (toggleAction === false) {
      this.setState({
        searchData: []
      })
    } else {
      this.setState({
        selectedProviderId: "",
        selectedProviderName: "",
        selectedProviderCity: "",
        selectedProviderState: "",
        updateStatusMessage: ""
      })
    }

  }

  updateProvider() {
    const statusIndicator = <CircularProgress size={20}/>
    const statusMessage = 'updating...'
    this.setState({
      updateStatusIndicator: statusIndicator,
      updateStatusMessage: statusMessage,
      disableUpdateButton: true
    })
    const updateProviderData = {
      userId: sessionStorage.getItem('userId'),
      providerId: this.state.selectedProviderId,
      updateAction: 'addForce',
      isPrimary: '1'
    }
    axios.post(`${API_ROOT}/provider/`, updateProviderData, {headers: getApiHeaders()})
      .then(res => this.handleUpdateProvidersResponse(res));
  }

  handleUpdateProvidersResponse(res) {
    var responseMessage = ''
    var reloadWindow = false
    if (res.data['error']) {
      responseMessage = 'There was an error entering your dentist. Please select another dentist or contact ' + SUPPORT_EMAIL + ' if you continue to have issues.'
    } else {
      sessionStorage.setItem('primaryDentist', this.state.selectedProviderId);
      responseMessage = 'We have updated your dentist and are taking you to your account.'
      reloadWindow = true
    }
    this.setState({
      updateStatusIndicator: '',
      updateStatusMessage: responseMessage,
      disableUpdateButton: false
    })
    if (reloadWindow) {
      window.location.reload();
    }
  }
//

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridItem xs={12} sm={12} style={this.state.showPreLoginHeader ? {} : { display: 'none' }} >
          <PreLoginHeader />
        </GridItem>
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12} md={12} lg={10}>
            <h4 className={classes.infoText} style={this.state.headerText ? {} : { display: 'none' }}>
              {this.state.headerText}
            </h4>
          </GridItem>
          <GridItem xs={12} sm={12} style={this.state.subheaderText ? {} : { display: 'none' }}>
            <p className={classes.infoText}>{this.state.subheaderText}</p>
          </GridItem>
        </GridContainer>
        <GridContainer justifyContent="center" className={classes.infoText}>

          <GridItem xs={12} sm={12} md={12} lg={10} style={this.state.showSearchOption || this.state.haveProviderFromUrl ? { display: 'none' } : {}}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={10}>
                You have selected {this.state.selectedProviderName} in {this.state.selectedProviderCity}, {this.state.selectedProviderState}
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={10}>
                If that's not who you want

                <Button
                  className={classes.updateProfileButton}
                  onClick={() => this.toggleSearch(true)}
                  size="sm"
                  round
                  color="cirrusBlue"
                >
                  search again
                </Button>

              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={10}>
                {this.state.confirmationText}
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={10} style={this.state.showConfirmButton ? {} : { display: 'none' }}>
                <Button
                  className={classes.updateProfileButton}
                  onClick={() => this.updateProvider()}
                  round
                  color="cirrusBlue"
                  disabled={this.state.disableUpdateButton}
                  id="updateProviderButton"
                >
                  confirm
                </Button>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={10}>
                {this.state.updateStatusIndicator} {this.state.updateStatusMessage}
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={10} style={this.state.showSearchOption ? {} : { display: 'none' }} id="dentistSearchDisplay">
            {this.state.providerSelectArea}
            <form onSubmit={this.onSubmitProviderSearch}>
              <GridContainer>
                <GridItem xs={6} sm={6} md={3}>
                  <CustomInput
                    labelText="First Name"
                    id="providerFirstName"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleChange,
                      value: this.state.providerFirstName
                    }}

                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomInput
                    labelText="Last Name/Company Name"
                    id="providerLastName"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleChange,
                      value: this.state.providerLastName
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={3}>

                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                    onSubmit={this.onSubmitProviderSearch}
                  >
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      state
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.providerState}
                      onChange={this.handleChangeSelect}

                      inputProps={{
                        id: "providerState",
                        name: "providerState"

                      }}

                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classes.selectMenuItem
                        }}
                      >
                        Choose state
                      </MenuItem>
                      {usStateList.map((usState) =>
                        <MenuItem classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected
                        }} key={usState.abbreviation} value={usState.abbreviation} >{usState.name}</MenuItem>
                      )}

                    </Select>
                  </FormControl>

                </GridItem>
                <GridItem xs={6} sm={6} md={2}>
                  <Button id="providerSearch" color="cirrusBlue" className={classes.updateProfileButton} type="submit">
                    Search
                  </Button>
                </GridItem>
              </GridContainer>
            </form>
            <span style={this.state.showProviderSearchResults ? {} : { display: 'none' }}>
              <MaterialTable
                title=''
                columns={[
                  { title: 'name', field: 'name'},
                  { title: 'dentists', field: 'dentists' },
                  { title: 'city', field: 'addressCity' },
                  { title: 'state', field: 'addressState' },
                  { title: '', field: 'actions' },
                ]}
                data={this.state.searchData}
                options={tableOptions}
                style={tableStyle}
              />
            </span>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={10} style={this.state.haveProviderFromUrl && this.state.selectedProviderName ? {} : { display: 'none' }}>
            <h4>
              Welcome to the sign up form for a membership with {this.state.selectedProviderName} in {this.state.selectedProviderCity}, {this.state.selectedProviderState}.
            </h4>
            <h4>
              We'll take you through a few simple steps to get signed up.
            </h4>
            <h4>
              Click the "next" button to select your subscription plan.

            </h4>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withRouter(withStyles(style)(Dentist));